export default "__VITE_ASSET__DQkoK4i3__"